import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpDeleteUser} from '@/features/users/http/users.http'

export const useDeleteUser = (userId: string, options?: Omit<UseMutationOptions, 'mutationFn'>) =>
    useMutation({
        mutationFn: () => httpDeleteUser({urlParams: {userId}}),
        ...options
    })
